module.exports = __webpack_public_path__ + "media/images/ng_banner-719e3fffa6e8bea79da69b27ad1be64a.jpg";